/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface UtmSaveRequest
 */
export interface UtmSaveRequest {
  /**
   *
   * @type {string}
   * @memberof UtmSaveRequest
   */
  utm_source?: string | null
  /**
   *
   * @type {string}
   * @memberof UtmSaveRequest
   */
  utm_medium?: string | null
  /**
   *
   * @type {string}
   * @memberof UtmSaveRequest
   */
  utm_campaign?: string | null
  /**
   *
   * @type {string}
   * @memberof UtmSaveRequest
   */
  utm_content?: string | null
  /**
   *
   * @type {string}
   * @memberof UtmSaveRequest
   */
  utm_term?: string | null
}

/**
 * Check if a given object implements the UtmSaveRequest interface.
 */
export function instanceOfUtmSaveRequest(
  value: object
): value is UtmSaveRequest {
  return true
}

export function UtmSaveRequestFromJSON(json: any): UtmSaveRequest {
  return UtmSaveRequestFromJSONTyped(json, false)
}

export function UtmSaveRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UtmSaveRequest {
  if (json == null) {
    return json
  }
  return {
    utm_source: json['utm_source'] == null ? undefined : json['utm_source'],
    utm_medium: json['utm_medium'] == null ? undefined : json['utm_medium'],
    utm_campaign:
      json['utm_campaign'] == null ? undefined : json['utm_campaign'],
    utm_content: json['utm_content'] == null ? undefined : json['utm_content'],
    utm_term: json['utm_term'] == null ? undefined : json['utm_term'],
  }
}

export function UtmSaveRequestToJSON(value?: UtmSaveRequest | null): any {
  if (value == null) {
    return value
  }
  return {
    utm_source: value['utm_source'],
    utm_medium: value['utm_medium'],
    utm_campaign: value['utm_campaign'],
    utm_content: value['utm_content'],
    utm_term: value['utm_term'],
  }
}
